import { Grid, TextField, Button, IconButton, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Chip from "@mui/material/Chip";
import { Controller } from "react-hook-form";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { useState } from "react";

export const EmployeesForm = ({
  nrpList,
  control,
  errors,
  employeesFields,
  handleAddNewEmployee,
  handleRemoveEmployee,
  t,
}) => {
  const selectAllItem = {
    label: t("App.infonavitRequests.filter.selectAll"),
    value: t("App.infonavitRequests.filter.selectAll"),
  };

  const [currentEmployee, setCurrentEmployee] = useState(0);

  /**
   * filterOptions para el autocomplete de compañías
   */
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 200,
  });

  /**
   * Add a new employee
   */
  const addEmployee = () => {
    handleAddNewEmployee({ nrp: "", nss: "" });
  };

  /**
   * Remove an employee
   */
  const removeEmployee = (index) => {
    handleRemoveEmployee(index);

    handleSetCurrentEmployee(index - 1 >= 0 ? index - 1 : 0);
  };

  const handleSetCurrentEmployee = (index) => {
    if (index < 0) index = 0;
    else if (index > employeesFields.length) index = employeesFields.length - 1;

    setCurrentEmployee(index);
  };

  return (
    <Grid container alignItems="center" gap="2rem" paddingTop="1.5rem">
      {/* Mobile */}
      <Grid
        item
        container
        xs="12"
        justifyContent="flex-start"
        display={{ xs: "flex", sm: "none" }}
      >
        <Button
          type="button"
          startIcon={<AddIcon sx={{ fontSize: 22 }} />}
          className="btn__filled__gradient"
          onClick={addEmployee}
          style={{ width: "100%" }}
        >
          {t("App.infonavitRequests.addEmployees.addBtn")}
        </Button>
      </Grid>

      {employeesFields.map((employee, index) => {
        return (
          <Grid
            item
            xs="12"
            key={employee?.id}
            display={{
              xs: currentEmployee !== index ? "none" : "block",
              sm: "block",
            }}
          >
            <Grid
              container
              gap={{ xs: "2rem", sm: "1rem" }}
              alignItems="center"
            >
              {/* Mobile */}
              <Grid item xs="12" display={{ xs: "block", sm: "none" }}>
                <Button
                  type="button"
                  startIcon={<DeleteOutlineIcon sx={{ fontSize: 22 }} />}
                  className="btn__outlined__blue"
                  onClick={() => removeEmployee(index)}
                  disabled={employeesFields.length === 1}
                  style={{ width: "100%" }}
                >
                  {t("App.infonavitRequests.addEmployees.deleteBtn")}
                </Button>
              </Grid>

              <Grid item xs="12" sm>
                <Controller
                  name={`employees.${index}.nrp`}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      noOptionsText={t("App.validationMessages.noMatchFilter")}
                      className={
                        errors?.employees?.[index]?.nrp
                          ? "select__filters__full select__filters__errors"
                          : "select__filters__full"
                      }
                      options={nrpList.map((nrp) => nrp.value)}
                      value={value ?? ""}
                      filterOptions={filterOptions}
                      onChange={(event, opt) => onChange(opt)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t(
                            "App.infonavitRequests.addEmployees.nrpLabel"
                          )}
                          FormHelperTextProps={{
                            style: {
                              margin: "-5px 0 1px 0px",
                              color: "#e52900",
                              fontSize: 10,
                            },
                          }}
                          helperText={
                            errors?.employees?.[index]?.nrp
                              ? errors.employees?.[index]?.nrp.message
                              : ""
                          }
                          InputLabelProps={{
                            style: {
                              margin: "-5px 0 0 -10px",
                              padding: "0 0 0 5px",
                              color: "#8c8d9d",
                              fontSize: 13,
                            },
                          }}
                        />
                      )}
                      renderTags={(values) => {
                        const size = values.filter(
                          (item) => item.value !== selectAllItem.value
                        ).length;
                        const label =
                          size > 1
                            ? t("App.autocomplete.selected")
                            : t("App.autocomplete.oneSelected");

                        return (
                          <Chip
                            label={`${size} ${label}`}
                            className="autocomplete-chip"
                            variant="filled"
                          />
                        );
                      }}
                    />
                  )}
                  control={control}
                />
              </Grid>

              <Grid item xs="12" sm>
                <Controller
                  name={`employees.${index}.nss`}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      onChange={onChange}
                      value={value}
                      label={t("App.infonavitRequests.addEmployees.nssLabel")}
                      className={`${
                        errors?.employees?.[index]?.nss
                          ? "select__filters__full select__filters__errors"
                          : "select__filters__full"
                      } full-width`}
                      FormHelperTextProps={{
                        style: {
                          margin: "-5px 0 1px 0px",
                          color: "#e52900",
                          fontSize: 10,
                        },
                      }}
                      helperText={
                        errors?.employees?.[index]?.nss
                          ? errors.employees?.[index]?.nss.message
                          : ""
                      }
                      InputLabelProps={{
                        style: {
                          margin: "-5px 0 0 -10px",
                          padding: "0 0 0 5px",
                          color: "#8c8d9d",
                          fontSize: 13,
                        },
                      }}
                    />
                  )}
                />
              </Grid>

              {/* Not mobile */}
              <Grid item xs="auto" display={{ xs: "none", sm: "block" }}>
                <Button
                  type="button"
                  startIcon={<DeleteOutlineIcon sx={{ fontSize: 22 }} />}
                  className="btn__outlined__blue"
                  onClick={() => removeEmployee(index)}
                  disabled={employeesFields.length === 1}
                >
                  {t("App.infonavitRequests.addEmployees.deleteBtn")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        );
      })}

      {/* Not mobile */}
      <Grid
        item
        container
        xs="12"
        justifyContent="flex-start"
        display={{ xs: "none", sm: "flex" }}
      >
        <Button
          type="button"
          startIcon={<AddIcon sx={{ fontSize: 22 }} />}
          className="btn__filled__gradient"
          onClick={addEmployee}
        >
          {t("App.infonavitRequests.addEmployees.addBtn")}
        </Button>
      </Grid>

      {/* Mobile */}
      <Grid item xs="12" display={{ xs: "flex", sm: "none" }}>
        <Box display="block" width="100%" overflow="auto">
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            gap="2.249rem"
            width="100%"
            minWidth="max-content"
          >
            <IconButton
              className="btn__filled__gradient"
              style={{
                borderRadius: "8px",
                visibility: currentEmployee === 0 ? "hidden" : "visible",
              }}
              onClick={() => handleSetCurrentEmployee(currentEmployee - 1)}
              variant="rounded"
            >
              <KeyboardArrowLeftIcon sx={{ fontSize: 22 }} />
            </IconButton>

            <strong style={{ fontSize: "14px", fontWeight: "700" }}>
              {t("App.infonavitRequests.addEmployees.mobileControlLabel", {
                count: currentEmployee + 1,
              })}
            </strong>

            <IconButton
              className="btn__filled__gradient"
              style={{
                borderRadius: "8px",
                visibility:
                  currentEmployee >= employeesFields.length - 1
                    ? "hidden"
                    : "visible",
              }}
              onClick={() => handleSetCurrentEmployee(currentEmployee + 1)}
            >
              <KeyboardArrowRightIcon sx={{ fontSize: 22 }} />
            </IconButton>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};
